import UserProfile2 from "../../components/UserProfile2";
import React, { Suspense, useEffect, useState } from "react";

export default function BlogsSection() {
  const [blogPostList, setBlogPostList] = useState([]);

  useEffect(() => {
    fetch("/BlogMarkdowns/BlogList.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch blog posts");
        }
        return response.json();
      })
      .then((data) => setBlogPostList(data))
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className="self-stretch">
      <div className="flex flex-col items-center bg-gray-100 py-12 md:py-8 sm:py-6">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            <Suspense fallback={<div>Loading feed...</div>}>
              {blogPostList.map((post, index) => (
                <div key={`blogGrid${index}`}>
                  <UserProfile2 {...post} />
                </div>
              ))}
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}
